export const environment = {
  production: true,
  msal: {
    clientId: '0e054801-386d-44dd-9085-df1c9b52d780',
    redirectUrl: 'https://firmenstammdaten.persona-service.de/',
    authority:
      'https://login.microsoftonline.com/1c2b8ed7-dafe-4820-ab1e-23ce67c5326e'
  },
  requiredScopes: ['api://prd-firmenstammdaten-bol/.default'],
  apiHost: 'https://prd-api-apim.azure-api.net',
  apiBaseUrl: 'prd-firmenstammdaten-bol/v1/api/rest/v1'
};
